import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { UliActivityType } from '../../../../../../common';
import { UliBriefModel } from '../models/uli-brief.model';
import { AllocationViewEndpoint } from '../../constants';
import { Observable } from 'rxjs';
import { RequestHeader } from '../../../../../constants';

@Injectable({ providedIn: 'root' })
export class UliBriefService {
  constructor(private http: WrapperHttpService) {}

  getUliBrief(compartmentId: number, type: UliActivityType, uli: string, hubId: number): Observable<UliBriefModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Uli}${AllocationViewEndpoint.Details}${
      AllocationViewEndpoint.Brief
    }?${getQueryStringFromObject({
      compartmentId,
      type,
      uli,
    })}`;
    const headers = new HttpHeaders({ [RequestHeader.IntrackHubId]: hubId.toString() });

    return this.http.withLoading().get(url, { headers });
  }
}
